import Head from 'next/head';
import { NextSeo } from 'next-seo';
import { SWRConfig } from 'swr';
import GateRankPredictor from '@cont/RankPredictor/Gate/GateRankPredictor';
import Layout from '@layout/FreeLayout/FreeLayout';
import { RANK_PREDICTOR } from '@constants/segment';
import fetchPageMetaInfo from '@api/fetchers/pageMetaInfo';
import { GATE_META_INFO, GATE_UID } from '@cont/RankPredictor/constant';
import { fetchGateSuggestions } from '@api/fetchers/rank-predictor';
import useFullRankPredictor from '@api/hooks/rank-predictor/useFullRankPredictor';

const GateRankPredictorLanding = ({ pageMetaInfo, fallbackData }) => {
  const metaTitle = pageMetaInfo?.title || GATE_META_INFO.title;
  const description = pageMetaInfo?.description || GATE_META_INFO.description;
  const { keys } = useFullRankPredictor(fallbackData);
  return (
    <>
      <SWRConfig
        value={{
          revalidateOnMount: false,
          dedupingInterval: 60 * 1000,
          fallback: {
            [keys.gateSuggestionSWRKey]: fallbackData?.gateSuggestionData
          }
        }}
      >
        <NextSeo
          title={metaTitle}
          description={description}
          openGraph={{
            title: metaTitle,
            description
          }}
        />
        <Head>
          <title>{metaTitle}</title>
        </Head>
        <GateRankPredictor />
      </SWRConfig>
    </>
  );
};

export const getStaticProps = async () => {
  try {
    const [metaInfo] = await Promise.all([
      fetchPageMetaInfo(RANK_PREDICTOR, GATE_UID)
    ]);
    const gateSuggestionData = await fetchGateSuggestions();
    return {
      props: {
        fallbackData: {
          gateSuggestionData
        },
        pageMetaInfo: metaInfo || null
      },
      revalidate: 60 * 20
    };
  } catch (error) {
    return {
      props: {
        fallbackData: null,
        pageMetaInfo: null
      },
      revalidate: 60 * 20
    };
  }
};

GateRankPredictorLanding.pageInfo = {
  isMWebSupported: true,
  layoutOptions: {
    hideHeader: true,
    hideIntercom: true,
    hideFreshbot: true,
    disableDarkMode: true
  }
};

export default GateRankPredictorLanding;
GateRankPredictorLanding.Layout = Layout;
GateRankPredictorLanding.Wrapper = null;
